export const getUserReferences = ( apiInstance: API.Client ) => ( uid: string ) => (
  apiInstance.Entity.collection( 'user' ).getReferences( uid )
)